var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiFrentePy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 150,
    viewBox: "0 0 232 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_5778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.697 45.1638C197.839 40.8742 195.325 37.0994 191.705 34.6636C188.085 32.2278 183.652 31.3288 179.374 32.1627L164.158 35.1973C167.649 33.3294 170.356 30.2645 171.784 26.561C173.213 22.8575 173.27 18.7619 171.942 15.0205C170.615 11.279 167.994 8.14078 164.554 6.17745C161.116 4.21412 157.089 3.55647 153.207 4.32428L51.7654 25.2222C49.5377 25.5415 47.3986 26.3147 45.4796 27.4946C43.5606 28.6743 41.9023 30.2358 40.6065 32.0827C39.3108 33.9297 38.405 36.0232 37.9449 38.2346C37.4847 40.4459 37.48 42.7284 37.9309 44.9417C38.3818 47.1549 39.2789 49.2522 40.567 51.1046C41.855 52.9571 43.5069 54.5251 45.421 55.7132C47.335 56.9008 49.4709 57.6834 51.6972 58.0117C53.9235 58.3405 56.1933 58.2086 58.3669 57.6241L64.0115 56.4643C61.2733 58.3493 59.1653 61.0199 57.9629 64.1271C56.7606 67.2344 56.5198 70.6333 57.2721 73.8797C58.0244 77.1261 59.7348 80.0694 62.1797 82.3252C64.6247 84.58 67.6904 86.0428 70.9762 86.5211L64.0694 87.863C61.8441 88.1655 59.7037 88.9211 57.7793 90.083C55.855 91.2449 54.187 92.7887 52.8777 94.6203C51.5684 96.4528 50.6453 98.5325 50.1648 100.735C49.6843 102.938 49.6567 105.214 50.0836 107.428C50.5104 109.641 51.3828 111.744 52.6472 113.607C53.9116 115.47 55.5416 117.055 57.4371 118.264C59.3328 119.472 61.4542 120.28 63.6715 120.637C65.8887 120.994 68.1553 120.892 70.3323 120.339L177.852 99.4438C181.776 98.6176 185.266 96.3847 187.67 93.1625C190.074 89.9403 191.226 85.9503 190.913 81.9368C190.599 77.924 188.841 74.1627 185.967 71.356C183.093 68.5493 179.299 66.8895 175.295 66.6869L185.732 64.6076C190.017 63.7498 193.788 61.221 196.219 57.5761C198.649 53.9312 199.54 49.4675 198.697 45.1638Z",
    fill: "#C7E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9991 64.0286C36.8746 64.0286 38.395 62.506 38.395 60.6276C38.395 58.7493 36.8746 57.2266 34.9991 57.2266C33.1235 57.2266 31.603 58.7493 31.603 60.6276C31.603 62.506 33.1235 64.0286 34.9991 64.0286Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.473 10.0132C145.011 10.0132 147.068 7.95313 147.068 5.41187C147.068 2.87063 145.011 0.810547 142.473 0.810547C139.936 0.810547 137.878 2.87063 137.878 5.41187C137.878 7.95313 139.936 10.0132 142.473 10.0132Z",
    stroke: "#808080",
    strokeWidth: 1.56,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2135 13.8031C73.3097 13.8031 75.009 12.0117 75.009 9.80193C75.009 7.59217 73.3097 5.80078 71.2135 5.80078C69.1173 5.80078 67.418 7.59217 67.418 9.80193C67.418 12.0117 69.1173 13.8031 71.2135 13.8031Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.146 97.5301C200.58 97.5301 201.742 96.4558 201.742 95.1301C201.742 93.8036 200.58 92.7285 199.146 92.7285C197.711 92.7285 196.548 93.8036 196.548 95.1301C196.548 96.4558 197.711 97.5301 199.146 97.5301Z",
    stroke: "#808080",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5422 131.014C79.9764 131.014 81.1391 129.939 81.1391 128.614C81.1391 127.287 79.9764 126.213 78.5422 126.213C77.108 126.213 75.9453 127.287 75.9453 128.614C75.9453 129.939 77.108 131.014 78.5422 131.014Z",
    stroke: "#808080",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68 90.038C156.539 90.038 172.638 73.9162 172.638 54.028C172.638 34.1399 156.539 18.0176 136.68 18.0176C116.821 18.0176 100.722 34.1399 100.722 54.028C100.722 73.9162 116.821 90.038 136.68 90.038Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2795 102.873V72.7292L54.5366 71.4297C51.1518 72.8158 43.2433 77.9781 38.6862 87.5412C34.1293 97.1039 47.8497 101.747 55.2795 102.873Z",
    fill: "#BA5C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.319 33.5391H57.4233C54.0896 33.5391 51.3872 36.3396 51.3872 39.7944V87.2834C51.3872 90.7383 54.0896 93.5388 57.4233 93.5388H166.319C169.653 93.5388 172.355 90.7383 172.355 87.2834V39.7944C172.355 36.3396 169.653 33.5391 166.319 33.5391Z",
    fill: "#515151",
    stroke: "#545454",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.485 35.1602H60.2249C58.9072 35.1602 57.8389 36.3258 57.8389 37.7637V89.3132C57.8389 90.7515 58.9072 91.9167 60.2249 91.9167H159.485C160.803 91.9167 161.871 90.7515 161.871 89.3132V37.7637C161.871 36.3258 160.803 35.1602 159.485 35.1602Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2799 60.0897C55.2799 59.8051 55.0494 59.5742 54.7652 59.5742C54.4809 59.5742 54.2505 59.8051 54.2505 60.0897V66.7908C54.2505 67.0754 54.4809 67.3062 54.7652 67.3062C55.0494 67.3062 55.2799 67.0754 55.2799 66.7908V60.0897Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4122 94.1095C77.6965 94.1095 77.9269 93.8784 77.9269 93.5938C77.9269 93.3092 77.6965 93.0781 77.4122 93.0781H69.1768C68.8925 93.0781 68.6621 93.3092 68.6621 93.5938C68.6621 93.8784 68.8925 94.1095 69.1768 94.1095H77.4122Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.192 94.1095C87.4763 94.1095 87.7067 93.8784 87.7067 93.5938C87.7067 93.3092 87.4763 93.0781 87.192 93.0781H78.9566C78.6723 93.0781 78.4419 93.3092 78.4419 93.5938C78.4419 93.8784 78.6723 94.1095 78.9566 94.1095H87.192Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.001 33.8004C98.2852 33.8004 98.5157 33.5696 98.5157 33.285C98.5157 33.0003 98.2852 32.7695 98.001 32.7695H82.5596C82.2753 32.7695 82.0449 33.0003 82.0449 33.285C82.0449 33.5696 82.2753 33.8004 82.5596 33.8004H98.001Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.387 41.3516H68.3224C67.4316 41.3516 66.7095 42.0776 66.7095 42.9732V85.1353C66.7095 86.0313 67.4316 86.757 68.3224 86.757H151.387C152.278 86.757 153 86.0313 153 85.1353V42.9732C153 42.0776 152.278 41.3516 151.387 41.3516Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0572 63.6973V74.724C49.3645 76.1179 45.4901 80.237 43.5342 85.5599C41.0892 92.2142 42.8844 96.7775 45.7056 96.2066C48.5267 95.6366 50.493 93.925 53.8783 90.1231C56.5866 87.081 58.8043 81.9485 60.323 75.8643C60.1349 73.7731 62.0862 67.4277 65.0689 65.7885C68.4049 63.955 70.2064 65.5014 70.429 65.7885C71.1032 66.6581 70.8052 69.4009 69.4886 74.724C68.1721 80.0473 66.4794 89.3626 66.4794 101.72C66.4794 111.606 60.9323 119.59 58.4246 122.633L63.4702 141.263C63.2821 142.087 60.5362 143.849 51.0572 144.306C41.5781 144.762 36.1992 142.467 34.6946 141.263C34.1931 137.271 34.6947 126.054 31.1211 111.606C26.8475 94.3264 27.687 90.3129 29.3796 85.5599C30.7338 81.758 45.6657 68.1334 51.0572 63.6973Z",
    fill: "#E9766C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4993 73.3647C69.7944 73.0606 70.483 69.0585 70.7904 67.0956C70.4214 66.7152 69.3886 66.1833 68.2082 67.0956C66.7326 68.2353 66.3638 72.0349 66.3638 72.6049C66.3638 73.1745 69.1304 73.7446 69.4993 73.3647Z",
    fill: "#FCA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4488 91.5332C51.162 92.8216 45.6275 97.0775 43.7388 100.086",
    stroke: "#AB5450",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1398 122.124C59.6565 121.518 63.2588 115.495 64.3964 112.089C61.5524 110.763 59.2774 117.014 57.0022 119.663C55.1821 121.783 51.4408 123.071 49.7976 123.449C49.3426 125.114 49.9873 137.771 50.3665 143.891C56.2818 144.194 61.5525 142.251 63.4485 141.24L58.1398 122.124Z",
    fill: "#DB6C62"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M136.858 81.2047L139.31 78.7402",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M133.901 81.1779L139.476 76.1621",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M131.26 81.1788L139.476 73.8027",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M127.152 81.1787L139.476 68.1973",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M129.5 81.1777L139.476 71.1465",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M124.804 81.1771L139.476 66.4258",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M121.577 81.1782L139.476 63.1816",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M118.827 81.2028L139.31 60.6094",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M112.658 81.2036L139.31 54.4082",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M109.252 81.1787L139.476 50.791",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M105.731 81.1778L139.476 47.25",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M115.708 81.1785L139.476 57.2812",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.053 86.7285C183.446 88.1223 186.381 92.165 186.989 97.1847",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_899_5778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.151 43.0352H75.8489C74.2421 43.0352 72.9395 44.3378 72.9395 45.9446V81.505C72.9395 83.1119 74.2421 84.4145 75.8489 84.4145H141.151C142.758 84.4145 144.06 83.1119 144.06 81.505V45.9446C144.06 44.3378 142.758 43.0352 141.151 43.0352Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.504 44.3281H76.4953C75.4241 44.3281 74.5557 45.1965 74.5557 46.2678V81.1816C74.5557 82.2528 75.4241 83.1212 76.4953 83.1212H140.504C141.575 83.1212 142.444 82.2528 142.444 81.1816V46.2678C142.444 45.1965 141.575 44.3281 140.504 44.3281Z",
    fill: "#E7F0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5386 54.0273H78.7584C78.0443 54.0273 77.4653 54.6063 77.4653 55.3204V74.717C77.4653 75.4312 78.0443 76.0101 78.7584 76.0101H96.5386C97.2528 76.0101 97.8317 75.4312 97.8317 74.717V55.3204C97.8317 54.6063 97.2528 54.0273 96.5386 54.0273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4266 78.918H77.7887C77.0745 78.918 76.4956 79.4969 76.4956 80.2111C76.4956 80.9252 77.0745 81.5042 77.7887 81.5042H89.4266C90.1408 81.5042 90.7197 80.9252 90.7197 80.2111C90.7197 79.4969 90.1408 78.918 89.4266 78.918Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6076 77.625H77.1421C76.9636 77.625 76.8188 77.7697 76.8188 77.9483C76.8188 78.1268 76.9636 78.2716 77.1421 78.2716H83.6076C83.7862 78.2716 83.9309 78.1268 83.9309 77.9483C83.9309 77.7697 83.7862 77.625 83.6076 77.625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7283 51.7643C81.1566 51.7643 82.3145 50.4617 82.3145 48.8548C82.3145 47.2479 81.1566 45.9453 79.7283 45.9453C78.3 45.9453 77.1421 47.2479 77.1421 48.8548C77.1421 50.4617 78.3 51.7643 79.7283 51.7643Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4679 74.9342H78.7983C78.9782 74.4512 79.2937 74.0304 79.7071 73.7226C80.3607 73.263 81.0748 72.896 81.8291 72.6322C82.5348 72.3486 83.2447 72.0722 83.9368 71.7567C84.249 71.6188 84.5276 71.415 84.7537 71.1593C84.9798 70.9037 85.148 70.6022 85.2467 70.2755C85.3534 69.9644 85.3974 69.6353 85.3761 69.3072C85.3549 68.979 85.2688 68.6583 85.1229 68.3636C84.6603 67.4704 84.1272 66.6111 83.7199 65.693C82.6463 63.2727 82.7145 60.8733 84.0994 58.5942C84.8129 57.4198 85.9505 56.8624 87.2856 56.7221C88.19 56.5997 89.1099 56.7709 89.9096 57.2106C90.8614 57.7521 91.3838 58.6204 91.7685 59.6277C92.4603 61.4381 92.3446 63.2439 91.8419 65.0665C91.6191 66.0412 91.2201 66.967 90.6645 67.7982C90.4734 68.0637 90.3218 68.3556 90.2145 68.6646C90.1009 68.959 90.0447 69.2723 90.049 69.5878C90.0656 70.1318 90.2575 70.6559 90.5961 71.082C90.9346 71.5081 91.4017 71.8134 91.9279 71.9526C93.2227 72.3002 94.4382 72.895 95.5072 73.7041C95.915 74.0375 96.2433 74.4577 96.4679 74.9342Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M139.56 44.3008L142.261 47.0018",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M136.302 44.3301L142.444 49.8258",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M133.392 44.3301L142.444 52.412",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M128.866 44.3301L142.444 58.5542",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M131.453 44.3301L142.444 55.3215",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M126.28 44.3301L142.444 60.4939",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M122.724 44.3301L142.444 64.0499",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M119.694 44.3008L142.261 66.8671",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M112.898 44.3008L142.261 73.663",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M109.146 44.3301L142.444 77.6275",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M105.267 44.3301L142.444 81.5068",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M116.258 44.3301L142.444 70.5154",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.885 77.6249C130.211 77.6989 129.747 77.2438 129.214 76.9926C129.036 76.8752 128.873 76.7361 128.729 76.5785C128.627 76.4921 128.518 76.4149 128.366 76.2988V77.6963C129.225 77.6527 130.063 78.0109 130.885 77.6249Z",
    fill: "white",
    fillOpacity: 0.19,
    stroke: "white",
    strokeOpacity: 0.36,
    strokeWidth: 0.161638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.519 80.1348C128.621 79.8169 127.806 79.301 127.135 78.6253C126.463 77.9495 125.952 77.1313 125.64 76.2312C125.435 75.7041 125.378 75.1314 125.473 74.5741C125.545 74.2601 125.688 73.9669 125.892 73.7172C126.096 73.4674 126.354 73.268 126.647 73.1342C126.941 72.9875 127.28 72.9564 127.596 73.047C128.23 73.2642 128.445 74.043 128.51 74.7099C128.654 76.1912 128.519 77.6863 128.113 79.1181C128.143 78.9957 128.136 78.8672 128.094 78.7487C128.051 78.6301 127.974 78.5269 127.873 78.4518C127.668 78.3054 127.432 78.2068 127.184 78.1631C126.296 77.9491 124.664 77.2647 123.984 77.8722C122.697 79.689 126.789 77.6491 127.815 78.0985C128.084 78.2158 128.325 78.3894 128.597 78.499C128.729 78.5634 128.873 78.5975 129.02 78.5989C129.167 78.6003 129.312 78.5689 129.445 78.5071C129.585 78.4173 129.702 78.298 129.791 78.1576C130.033 77.8126 130.22 77.4321 130.346 77.0297L130.338 77.5372C130.334 77.5632 130.336 77.5896 130.342 77.615C130.349 77.6404 130.36 77.6642 130.376 77.685C130.427 77.7351 130.512 77.7144 130.578 77.6866C130.895 77.553 131.168 77.3321 131.364 77.0494C131.307 77.1464 131.285 77.2604 131.304 77.3715C131.322 77.4827 131.379 77.5838 131.464 77.6572C131.641 77.7993 131.862 77.8754 132.089 77.8725C132.366 77.8978 132.644 77.8461 132.893 77.7232C133.142 77.6002 133.352 77.4108 133.5 77.1758C133.758 76.6867 133.526 75.9584 132.987 75.8313C132.851 76.0915 132.783 76.3819 132.79 76.6754C132.796 76.9689 132.876 77.2562 133.023 77.5104C133.179 77.7591 133.414 77.948 133.69 78.0466C133.967 78.1453 134.268 78.1479 134.547 78.0542L132.197 78.7731C132.049 78.833 131.888 78.8521 131.73 78.8284C131.429 78.7541 131.298 78.4082 131.213 78.1098L130.19 74.5017",
    stroke: "#DCE4EA",
    strokeWidth: 0.484914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.263 79.7324H134.888",
    stroke: "#DCE4EA",
    strokeWidth: 0.484914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.097 46.9141H84.7389C84.2925 46.9141 83.9307 47.2759 83.9307 47.7223C83.9307 48.1686 84.2925 48.5304 84.7389 48.5304H116.097C116.543 48.5304 116.905 48.1686 116.905 47.7223C116.905 47.2759 116.543 46.9141 116.097 46.9141Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.327 49.5H84.5772C84.2201 49.5 83.9307 49.7895 83.9307 50.1466C83.9307 50.5036 84.2201 50.7931 84.5772 50.7931H103.327C103.684 50.7931 103.974 50.5036 103.974 50.1466C103.974 49.7895 103.684 49.5 103.327 49.5Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.075 56.6133H100.903C100.457 56.6133 100.095 56.9751 100.095 57.4215C100.095 57.8678 100.457 58.2297 100.903 58.2297H106.075C106.522 58.2297 106.884 57.8678 106.884 57.4215C106.884 56.9751 106.522 56.6133 106.075 56.6133Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.946 62.4316H100.903C100.457 62.4316 100.095 62.7935 100.095 63.2398C100.095 63.6862 100.457 64.048 100.903 64.048H120.946C121.392 64.048 121.754 63.6862 121.754 63.2398C121.754 62.7935 121.392 62.4316 120.946 62.4316Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.743 68.25H100.903C100.457 68.25 100.095 68.6118 100.095 69.0582C100.095 69.5045 100.457 69.8664 100.903 69.8664H116.743C117.19 69.8664 117.552 69.5045 117.552 69.0582C117.552 68.6118 117.19 68.25 116.743 68.25Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.379 74.7168H100.741C100.384 74.7168 100.095 75.0063 100.095 75.3633C100.095 75.7204 100.384 76.0099 100.741 76.0099H112.379C112.736 76.0099 113.026 75.7204 113.026 75.3633C113.026 75.0063 112.736 74.7168 112.379 74.7168Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.793 54.9961H100.418C100.239 54.9961 100.095 55.1408 100.095 55.3194C100.095 55.4979 100.239 55.6426 100.418 55.6426H109.793C109.972 55.6426 110.116 55.4979 110.116 55.3194C110.116 55.1408 109.972 54.9961 109.793 54.9961Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.379 60.8164H100.418C100.239 60.8164 100.095 60.9611 100.095 61.1397C100.095 61.3182 100.239 61.463 100.418 61.463H112.379C112.558 61.463 112.702 61.3182 112.702 61.1397C112.702 60.9611 112.558 60.8164 112.379 60.8164Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.793 66.6348H100.418C100.239 66.6348 100.095 66.7795 100.095 66.958C100.095 67.1366 100.239 67.2813 100.418 67.2813H109.793C109.972 67.2813 110.116 67.1366 110.116 66.958C110.116 66.7795 109.972 66.6348 109.793 66.6348Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 72.7773H100.418C100.239 72.7773 100.095 72.9221 100.095 73.1006C100.095 73.2792 100.239 73.4239 100.418 73.4239H111.733C111.911 73.4239 112.056 73.2792 112.056 73.1006C112.056 72.9221 111.911 72.7773 111.733 72.7773Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48 109.541C141.239 111.213 139.151 112.772 138.011 113.342C136.556 111.251 133.645 106.841 133.645 105.928C133.645 104.788 134.784 104.217 135.923 104.217C137.062 104.217 139.53 107.449 140.48 109.541Z",
    fill: "#FCA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.615 76.6504C160.539 80.5158 168.955 90.0348 171.232 97.1821",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.612 82.3535C174.46 84.1908 180.193 89.6541 180.345 96.8022",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.551 126.081L158.134 122.279C162.69 114.522 154.337 94.7125 149.591 85.7773C156.615 92.8111 160.412 103.078 163.26 111.443C165.538 118.134 163.07 123.99 161.551 126.081Z",
    fill: "#BA5C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.764 123.73C200.626 134.261 201.41 138.956 202.419 142.079C202.852 143.419 202.091 144.967 200.705 145.211L176.963 149.394C175.076 146.154 168.34 143.36 160.23 141.264C152.119 139.167 147.593 130.4 145.706 126.207C143.82 122.013 134.955 108.291 134.201 106.767C133.447 105.242 133.069 103.717 136.276 103.717C139.482 103.717 142.689 105.813 147.593 112.104C152.497 118.392 157.589 122.395 158.155 122.395C158.721 122.395 160.606 113.628 157.589 104.67C154.571 95.7122 149.101 84.086 147.593 82.3712C146.084 80.6565 137.03 66.3616 136.842 62.7405C136.653 59.1193 139.105 58.9286 141.368 59.5003C143.179 59.958 152.182 71.1265 156.458 76.6533C163.851 77.2637 169.974 80.7199 172.112 82.3712C177.092 82.0671 180.726 85.0403 181.92 86.5647C186.296 86.7171 190.03 93.8701 191.351 97.4279C194.935 106.768 193.048 106.386 197.764 123.73Z",
    fill: "#E9766C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.202 59.7307C139.568 58.6662 141.302 59.4142 141.998 59.9209L145.985 64.6739L145.605 64.8637C144.542 65.7766 141.998 66.258 140.859 66.3848C139.404 64.6105 136.835 60.7956 138.202 59.7307Z",
    fill: "#FCA2AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_899_5778",
    x: 71.6463,
    y: 42.3886,
    width: 73.7068,
    height: 43.9651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.646552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.646552
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_5778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_5778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_5778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 150,
    fill: "white",
    transform: "translate(28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiFrentePy);
export default __webpack_public_path__ + "static/media/CIFrente_py.7468e7f3aed98bfdf06369c423b9f7de.svg";
export { ForwardRef as ReactComponent };